import Request from "./index";

class api {
  // 获取用户提问记录列表（分页）
  static getUserQuestionPage(data) {
    return Request.get(`/ai_class/ai_assistant/user_question/page`, {
      params: data
    });
  }

  // 获取提问快捷指令列表（分页）
  static getQuickInstructionPage(data) {
    return Request.get(`/ai_class/ai_assistant/quick_instruction/page`, {
      params: data
    });
  }

  // 获取用户问答历史记录
  static getHistoryList(data) {
    return Request.get(`/ai_class/ai_assistant/question_answer_history/list`, {
      params: data
    });
  }

  // 删除对话
  static deleteQuestion(id) {
    return Request.delete(`/ai_class/ai_assistant/remove_chat?id=${id}`);
  }
}

export default api;
